<template>
  <button class="btn btn-outline-primary">
    <slot></slot>
  </button>
</template>
